// Existing app-store support URLs stay directly reachable, but unlisted.
export const appSupportRoutes = [
  { path: '/stovewatch-feedback', app: 'StoveWatch' },
  { path: '/fitcheck-feedback', app: 'FitCheck' },
  { path: '/hoboken-sailing-feedback', app: 'Hoboken Sailing' },
  { path: '/river-vale-streets-feedback', app: 'River Vale Streets' },
  { path: '/mini-hockey-scoreboard', app: 'Mini Hockey Scoreboard' },
];
